module.exports = __webpack_public_path__ + "static/img/AF@3x.74d62c57.png";